module.exports = __webpack_public_path__ + "static/media/arrows.a2434d61.svg";